module.exports = __webpack_public_path__ + "static/media/img-3.8c392f62.png";